import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ChargeQtyAdjMaintenanceCont from "presentation/view/container/ChargeQtyAdj/ChargeQtyAdjContMain";
CommonEntrypoint(<ChargeQtyAdjMaintenanceCont />) 
